import{getPlatform as c}from"@tencentcloud/universal-api";var n="pc"===c(),o="h5"===c(),p=function(c){n="pc"===c,o="h5"===c};export{o as isH5,n as isPC,p as setPlatform};
